<div class="container">
  <form [formGroup]="i18nSelectorForm" class="row">
    <eps-radio-group
      label="Type"
      [options]="types"
      [disabled]="loading || saving"
      formControlName="type"
      class="col-12"
      hideOptionalMarker
    ></eps-radio-group>
    <eps-select
      #lang
      [options]="languages"
      formControlName="language"
      class="col-12"
      label="Language"
      hideOptionalMarker
      *ngIf="isJson()"
    ></eps-select>
  </form>

  <div class="col-12 buttons" *ngIf="isCsv()">
    <eps-button
      [busy]="loading"
      label="ADMIN.I18N.BUTTONS.EDIT"
      (buttonClick)="!saving && editAllCsv.emit()"
      [disabled]="loading || saving"
      ></eps-button>
  </div>
</div>
